import React, { FC, useCallback, useEffect, useState } from "react";
import { RootState } from "@/store/redux/store";
import { useSelector } from "react-redux";
import TransportOnMap from "./TransportOnMap";
import { ITransportVeh } from "../../../../../api/transport/types";
import useRoadmaps from "../../../../../pages/Map/hooks/useRoadmaps";
import { formatDateForLocale } from "../../../../../utils/dateFunctions";
import { TTransportType } from "../../../../../pages/Map/types/types";
import useTransport from "../../../../../pages/Map/hooks/useTransport";


const RenderPacemrkAllTransports = ({ ymapsApi }: { ymapsApi: any }) => {
    const { vehTransports, roadmaps, mapMode, transportTypes } = useSelector((state: RootState) => state.mapScreen);
    const [transportsInfo, setTransportsInfo] = useState<ITransportVeh[]>()
    const { zoom } = useSelector((state: RootState) => state.mapScreen);
    const [size, setSize] = useState<[number, number] | undefined>([30, 30]);
    const { selectRoadmapByForm } = useRoadmaps();
    const { getAllTransportOnCity } = useTransport();

    const click = (id: number, routeName: string) => {
        selectRoadmapByForm(id, routeName);
    }

    useEffect(() => {
        if (zoom !== undefined) {
            if (zoom < 11) {
                setSize([15, 15]);
            } else if (zoom >= 11 && zoom < 12) {
                setSize([30, 30]);
            } else if (zoom >= 12 && zoom < 14) {
                setSize([35, 35]);
            } else if (zoom >= 14 && zoom < 15) {
                setSize([39, 39]);
            } else {
                setSize([49, 49]);
            }
        }
    }, [zoom])

    useEffect(() => {
        if (roadmaps && roadmaps.length > 0 && mapMode === 'roadMaps') {
            const roadmapsIds = roadmaps.map((route) => { if (route.route_id) return route.route_id.toString() });
            const transportsOnRoadmaps = vehTransports.filter(transport => transport.route_id && roadmapsIds.includes(transport.route_id.toString()));
            setTransportsInfo(transportsOnRoadmaps);
        } else {
            const filtredTypes = transportTypes.length > 0 ? vehTransports.filter(transport => transportTypes.includes(transport.veh_type.toUpperCase() as TTransportType)) : [];
            setTransportsInfo(filtredTypes);
        }

    }, [roadmaps, mapMode, vehTransports, transportTypes])

    // Обновление транспорта на карте
    useEffect(() => {
        const interval = setInterval(() => {
            if (transportsInfo?.length > 0) {
                getAllTransportOnCity(false, false);
            }
        }, 15000);

        return () => clearInterval(interval);
    }, [transportsInfo]);

    const onPlacemarkClick = useCallback((id: number, name?: string) => {
        click(id, name);
    }, []);

    return (
        <>
            {transportsInfo && transportsInfo.map((transport) => {
                //console.log(transport.low_floor ? transport.low_floor : null)

                return <TransportOnMap
                    ymapsApi={ymapsApi}
                    isLowFloor={transport?.low_floor === '1'}
                    key={transport.id}
                    size={size}
                    type={transport.veh_type}
                    hintContent={`
                        ${transport.route_name ? `Маршрут: ${transport.route_name}<br />` : ''}
                        ${transport.veh_type ? `${transport.veh_type}<br />` : ''}
                        ${transport.reg_number ? `${transport.reg_number}<br />` : ''}
                        ${transport.last_date ? `Актуальность: ${formatDateForLocale(transport.last_date)}<br />` : ''}
                        ${transport.veh_comment ? `${transport.veh_comment}<br />` : ''}
                        ${transport.veh_seat_number ? `Вместимость: ${transport.veh_seat_number}<br />` : ''}
                    `}
                    latitude={transport.lat}
                    longitude={transport.lon}
                    degree={transport.direction}
                    //closestLat ={transport.closest_point.}
                    id={transport.id}
                    handlePlacemarkClick={() => click(transport.route_id, transport.route_name)}
                />
            })}
        </>
    )
};

export default RenderPacemrkAllTransports;